export interface CustomerTicket {
  _id: string
  ticket_number: string
  subject: string
  status: 'open' | 'in_progress' | 'waiting_on_customer' | 'resolved' | 'closed'
  priority: 'low' | 'medium' | 'high' | 'urgent'
  customer_unread: boolean
  last_admin_reply: string | null
  created_at: string
  updated_at: string
}

export interface CustomerTicketMessage {
  _id: string
  sender_type: 'customer' | 'admin' | 'system'
  sender_admin?: {
    username: string
  } | null
  message: string
  attachments: Attachment[]
  created_at: string
}

export interface Attachment {
  originalname: string
  mimetype: string
  size: number
  location: string
}

export interface CustomerTicketDetailResponse {
  ticket: CustomerTicket
  messages: CustomerTicketMessage[]
}

export const STATUS_LABELS: Record<string, string> = {
  open: 'פתוח',
  in_progress: 'בטיפול',
  waiting_on_customer: 'ממתין לתגובה',
  resolved: 'נפתר',
  closed: 'סגור'
}

export const STATUS_COLORS: Record<string, string> = {
  open: 'warning',
  in_progress: 'primary',
  waiting_on_customer: 'info',
  resolved: 'success',
  closed: 'secondary'
}
